import styled from 'styled-components'

export const HistoryCheckboxWrapper = styled.div<{ sideMargin?: number }>`
  padding-top: 16px;
  display: flex;
  margin: 0 ${({ sideMargin }) => sideMargin || 0}px;
`
